<template>
  <div>
        <h1>{{tituloh1}}</h1>
        <h2>{{ datosexpediente.codigo }} <small>{{ datosexpediente.descripcion }}</small></h2>
        <div class="my-3">
            <div class="alert alert-info">
                Ya está todo listo para enviar el contrato a firmar a través de Signaturit<br />
                Cuando pulses CONFIRMAR EL ENVÍO se iniciará el proceso, enviando:
                <ul>
                    <li>Email personalizado a {{ datosexpediente.firmantes[0].nombre }} &lt;{{ datosexpediente.firmantes[0].email }}&gt;</li>
                    <li>
                        Contrato a firmar por las partes a través de Signaturit
                        <ul>
                            <li>En representación de <strong>MANUSA</strong>: {{ datosexpediente.firmantes[0].nombre }}, mediante efirma <strong>{{ datosexpediente.firmantes[0].modofirma }}</strong></li>
                            <li>En representación de <strong>{{ datosexpediente.firmantes[1].empresa }}</strong>: {{ datosexpediente.firmantes[1].nombre }} &lt;{{ datosexpediente.firmantes[1].email }}&gt;, mediante efirma <strong>{{ datosexpediente.firmantes[1].modofirma }}</strong></li>
                        </ul>
                    </li>
                </ul>
            </div>
        </div>

        <div class="w-100 d-flex justify-content-between mb-4">            
            <b-button @click="pasoatras" variant="danger">
                <b-icon-arrow-left-circle-fill></b-icon-arrow-left-circle-fill>
                Atrás
            </b-button>
            <b-button @click="confirmarenvio" class="bgcolor-manusa">
                Confirmo el envío
                <b-icon-arrow-right-circle-fill></b-icon-arrow-right-circle-fill>
            </b-button>
        </div>
  </div>
</template>

<script>
    export default {
        props: {
            tituloh1: {
                type: String,
                default: "Confirmación del envío realizado a Signaturit"
            },
            datosexpediente: Object,
        },
        methods: {
            confirmarenvio() {
                this.$emit('envio-confirmado')
            },
            pasoatras() {
                this.$emit('paso-atras')
            },
        },
        
    }
</script>